module.exports = __webpack_public_path__ + "static/about8-d5dcac141fabc9f96165bb2b2899c9fd.jpg";